import axios from "axios";

class AlertService {
    constructor(apiUrl) {
        this.apiUrl = apiUrl;
    }

    /**
     * @author Adriana Fernandez
     * @description Get the alerts of all companies
     * @date 19-10-2023
     * @param {String} token
     * @returns {Object}
     * @memberof AlertService
     */
    async getAllAlertConfigs(token, documentId) {
        let response = await axios.get(`${this.apiUrl}/alert-configs`, {
            params: {
                documentId
            },
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        return response.data;
    }

    /**
     * @author Adriana Fernandez
     * @description Create alert config
     * @date 23-10-2023
     * @param {String} token
     * @param {Object} data
     * @returns {Object}
     * @memberof AlertService
     */
    async createAlert(token, data) {
        let response = await axios.post(`${this.apiUrl}/alert`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

        return response.data;
    }

    /**
     * @author Adriana Fernandez
     * @description Delete alert
     * @date 27-10-2023
     * @param {String} token
     * @param {Integer} alertId
     * @returns {Object}
     * @memberof AlertService
     */
    async deleteAlert(token, alertId) {
        let response = await axios.delete(`${this.apiUrl}/alert?id=${alertId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

        return response.data;
    }
}

export { AlertService as default };